import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Instagram, Facebook } from "lucide-react";

/** Normalize an Instagram post URL to its /embed form. Returns null if not a post link. */
function igEmbedUrl(url) {
  const m = (url || "").match(/instagram\.com\/(p|reel)\/([A-Za-z0-9_-]+)/);
  return m ? `https://www.instagram.com/${m[1]}/${m[2]}/embed` : null;
}

/** Customer-facing social section: live Facebook Page preview + Instagram post embeds + follow links. */
export default function SocialLinks() {
  const [company, setCompany] = useState(null);
  useEffect(() => {
    api.get("/company-settings").then((r) => setCompany(r.data)).catch(() => {});
  }, []);

  if (!company || (!company.instagram_url && !company.facebook_url && !(company.instagram_post_urls || []).length)) return null;

  const igEmbeds = (company.instagram_post_urls || []).map(igEmbedUrl).filter(Boolean).slice(0, 3);
  const fbEmbed = company.facebook_url
    ? `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(company.facebook_url)}&tabs=timeline&width=340&height=420&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false`
    : null;

  return (
    <div className="mt-10 pb-6" data-testid="social-links">
      <div className="flex items-center justify-center gap-4 mb-5">
        <span className="text-[11px] uppercase tracking-widest text-zinc-600">Follow us</span>
        {company.instagram_url && (
          <a href={company.instagram_url} target="_blank" rel="noreferrer" data-testid="social-instagram"
            className="flex items-center gap-1.5 text-xs text-zinc-400 hover:text-[#D4AF37] transition-colors">
            <Instagram className="w-4 h-4" /> Instagram
          </a>
        )}
        {company.facebook_url && (
          <a href={company.facebook_url} target="_blank" rel="noreferrer" data-testid="social-facebook"
            className="flex items-center gap-1.5 text-xs text-zinc-400 hover:text-[#D4AF37] transition-colors">
            <Facebook className="w-4 h-4" /> Facebook
          </a>
        )}
      </div>

      {(fbEmbed || igEmbeds.length > 0) && (
        <div className="flex flex-wrap justify-center gap-4" data-testid="social-embeds">
          {fbEmbed && (
            <iframe
              src={fbEmbed}
              title="Facebook Page"
              width="340"
              height="420"
              style={{ border: "none", overflow: "hidden", borderRadius: "4px", background: "#fff" }}
              scrolling="no"
              frameBorder="0"
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              data-testid="fb-page-embed"
            />
          )}
          {igEmbeds.map((src) => (
            <iframe
              key={src}
              src={src}
              title="Instagram post"
              width="328"
              height="420"
              style={{ border: "none", overflow: "hidden", borderRadius: "4px", background: "#fff" }}
              scrolling="no"
              frameBorder="0"
              allowtransparency="true"
              data-testid="ig-post-embed"
            />
          ))}
        </div>
      )}
    </div>
  );
}
